import { useCallback } from 'react'

import { useUpdateUserSkins } from './useUpdateUserSkins'

export const useUpdateUserStarSkin = ({
  onSuccess,
}: {
  onSuccess?: () => void
} = {}) => {
  const { loading, handleUpdateUserSkins } = useUpdateUserSkins({
    onSuccess,
  })

  const handleUpdateUserStarSkin = useCallback(
    async (star: string) => {
      await handleUpdateUserSkins({ star })
    },
    [handleUpdateUserSkins]
  )

  return {
    loading,
    handleUpdateUserStarSkin,
  }
}
